import { FormControl } from '@@/form-components/FormControl';
import { RadioGroup } from '@@/RadioGroup/RadioGroup';

import { AuthTypeOption } from '../types';

const authTypeOptions = [
  { value: AuthTypeOption.Basic, label: 'Basic' },
  { value: AuthTypeOption.Token, label: 'Token' },
] as const;

type Props = {
  value: AuthTypeOption;
  onChange: (authorizationType: AuthTypeOption) => void;
};

export function AuthTypeSelector({ value, onChange }: Props) {
  return (
    <FormControl inputId="authorizationType" label="Authorization type">
      <RadioGroup
        options={authTypeOptions}
        selectedOption={value}
        onOptionChange={onChange}
        name="authorizationType"
      />
    </FormControl>
  );
}
